
export default {
  state: {
    navDivision: 0
  },
  mutations: {
    change_nav_division (state, p) {
      state.navDivision = p || 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/ui.js